import SalesPage from './SalesPage';

export default SalesPage;
